import React from 'react'
import styled from 'styled-components'
import { Autocomplete, TextField } from '../atom'

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
`

const AutoCompleteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

interface Props {
  label?: string
  placeholder?: string
  options: any[]
  value?: any
  width?: number
  setData?: any
  fieldName?: string
}

const AutoCompleteOnly = (props: Props) => {
  const { label, options, value, placeholder, width, fieldName, setData } =
    props

  const handleOnchange = (newValue: any) => {
    if (!fieldName) return

    setData((prevData: any) => {
      return {
        ...prevData,
        [fieldName]: newValue,
      }
    })
  }

  return (
    <Wrapper>
      <AutoCompleteWrapper>
        <Autocomplete
          options={options || []}
          value={value || null}
          style={{
            width: width || 136,
            textAlign: 'center',
            alignItems: 'center',
          }}
          getOptionLabel={(option) => String(option) || ''}
          renderInput={(params) => (
            <TextField
              {...params}
              style={{ textAlign: 'center', alignItems: 'center' }}
              placeholder={placeholder || '선택해 주세요'}
              variant="standard"
              label={value ? label : ''}
            />
          )}
          onChange={(event, newValue) => {
            handleOnchange(newValue)
          }}
        />
      </AutoCompleteWrapper>
    </Wrapper>
  )
}

export default AutoCompleteOnly
